import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import { BrowserRouter as Router } from 'react-router-dom';
import App from './Admin';
import ScrollRestoration from '../../shared/components/ScrollRestoration';

class Root extends PureComponent {
    static propTypes = {
        store: PropTypes.object.isRequired
    };

    render() {
        const { store } = this.props;

        return (
            <Provider store={store}>
                <Router>
                    <ScrollRestoration>
                        <App store={store} />
                    </ScrollRestoration>
                </Router>
            </Provider>
        );
    }
}

export default Root;
